import styled from '@emotion/styled';
import Image from 'next/image';

const StageWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  border-radius: 0.75rem;
  height: 220px;

  ${({ theme }) => theme.mq('md')} {
    height: auto;
  }
`;

const StyledImage = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;

  ${({ theme }) => theme.mq('md')} {
    height: auto;
    object-fit: initial;
  }
`;

export { StageWrapper, StyledImage };
